import { Chip } from "@mui/material";
import type { ChipProps } from "@mui/material";
import { statusColour } from "@/lib/status";
import { titleCase } from "@/lib/format";

/** A status, coloured the same way wherever it appears. */
export default function StatusChip({
  status, size = "small", ...rest
}: { status: string | null | undefined } & Omit<ChipProps, "color" | "label">) {
  return (
    <Chip
      size={size}
      label={titleCase(status) || "Unknown"}
      color={statusColour(status)}
      variant={statusColour(status) === "default" ? "outlined" : "filled"}
      {...rest}
    />
  );
}
